import keyMirror from '../../utils/keyMirror';
import api from "../../services/api/notificationService";
import { NOTIFICATION_STATUS_VALUE } from '../../constants';

export const actionTypes = keyMirror(
    {
        SET_PAGE_NOTIFICATIONS: null,
        GET_NOTIFICATION_SUMMARY_BY_TARGET: null,
        UPDATE_NOTIFICATION_COUNT: null,
        RESET_PAGE_NOTIFICATIONS: null,
        CREATE_PAGE_NOTIFICATION: null,
        MARK_NOTIFICATION_READ: null,
        MARK_ALL_NOTIFICATIONS_READ: null,
    },
    'Page'
);

// Action Creators
export const getNotificationSummaryByTarget = (id, target, agId) => dispatch => {
    api.GetCompanyNotificationsByTarget(id, target).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_NOTIFICATION_SUMMARY_BY_TARGET,
            payload: data,
        })
        if (agId) {
            dispatch({
                type: actionTypes.UPDATE_NOTIFICATION_COUNT,
                payload: agId,
            })
        }
    })
}

export const createNotification = async (data, successHandler, errorHandler) => dispatch => {
    api.CreateNotification(data).then(() => {
        dispatch({
            type: actionTypes.CREATE_PAGE_NOTIFICATION,
        })
        successHandler();
    }).catch((error) => {
        errorHandler(error);
    })
}

export const markNotificationAsRead = (id) => dispatch => {
    const status = NOTIFICATION_STATUS_VALUE.Read;
    api.UpdateNotificationStatus([id], status).then(() => {
        dispatch({
            type: actionTypes.MARK_NOTIFICATION_READ,
            payload: { id, status },
        });
    })
}

export const markAllNotificationsAsRead = (ids) => dispatch => {
    const status = NOTIFICATION_STATUS_VALUE.Read;
    api.UpdateNotificationStatus(ids, status).then(() => {
        dispatch({
            type: actionTypes.MARK_ALL_NOTIFICATIONS_READ,
            payload: {
                ids, status
            },
        })
    })
}

export const resetNotifications = () => dispatch => {
    dispatch({
        type: actionTypes.RESET_PAGE_NOTIFICATIONS,
        payload: null,
    });
}


// Reducer
export const initialState = {
    pageNotifications: null,
    unReadCount: null,
};

export default function notificationReducer(state = initialState, { type, payload }) {
    switch (type) {
        case actionTypes.GET_NOTIFICATION_SUMMARY_BY_TARGET: {
            return {
                ...state,
                pageNotifications: payload,
                unReadCount: payload?.filter(notification => notification.status !== NOTIFICATION_STATUS_VALUE.Read).length,
            }
        }
        case actionTypes.UPDATE_NOTIFICATION_COUNT: {
            const notificationsCount = state.pageNotifications?.filter(notification => {
                return notification.agId === parseInt(payload) && notification.status !== NOTIFICATION_STATUS_VALUE.Read
            }).length;
            return {
                ...state,
                unReadCount: notificationsCount,
            }
        }
        case actionTypes.MARK_NOTIFICATION_READ: {
            const pageNotificationsCopy = [...state.pageNotifications];
            const notificationIndex = pageNotificationsCopy.findIndex(notification => notification.id === payload.id);
            pageNotificationsCopy[notificationIndex].status = payload.status;

            return {
                ...state,
                pageNotifications: pageNotificationsCopy,
                unReadCount: state.unReadCount - 1,
            }
        }
        case actionTypes.MARK_ALL_NOTIFICATIONS_READ: {
            const pageNotificationsCopy = [...state.pageNotifications];
            payload.ids.forEach((id) => {
                const notificationIndex = pageNotificationsCopy.findIndex(
                    (notification) => notification.id === id
                );
                pageNotificationsCopy[notificationIndex].status = payload.status;
            });

            return {
                ...state,
                pageNotifications: pageNotificationsCopy,
                unReadCount: 0,
            }
        }
        case actionTypes.RESET_PAGE_NOTIFICATIONS: {
            return {
                ...state,
                pageNotifications: initialState.pageNotifications,
                unReadCount: initialState.unReadCount,
            }
        }
        default:
            return state;
    }
};
